import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { L } from 'harmony-language';
import React from 'react';

const BulkPreviewHeaderCell = styled(TableCell)({
    color: '#282973',
    textTransform: 'uppercase',
    fontSize: '11px',
    paddingTop: '0.2em',
    paddingBottom: '0.2em',
    border: 'none',
});

interface BulkPreviewTableHeadersProps {
    isOriginBased?: boolean;
}

export const BulkPreviewTableHeaders = (props: BulkPreviewTableHeadersProps) => {
    const { isOriginBased } = props;

    return (
        <TableHead>
            <TableRow>
                <BulkPreviewHeaderCell>{L.drafts()}</BulkPreviewHeaderCell>
                <BulkPreviewHeaderCell>{L.date()}</BulkPreviewHeaderCell>
                <BulkPreviewHeaderCell>{isOriginBased ? L.origin() : L.destination()}</BulkPreviewHeaderCell>
                <BulkPreviewHeaderCell>{L.cargoType()}</BulkPreviewHeaderCell>
                <BulkPreviewHeaderCell>{L.loadSize()}</BulkPreviewHeaderCell>
                <BulkPreviewHeaderCell>{L.loadWeight()}</BulkPreviewHeaderCell>
            </TableRow>
        </TableHead>
    );
};
